import React from 'react'
import './Loader.scss'

export interface LoaderProps {
  imgSrc?: string
  imgAlt?: string
  heading?: string
  subheading?: string
}

export const Loader: React.FC<LoaderProps> = ({ imgSrc, imgAlt, heading, subheading }) => {
  return (
    <div className="mk-loader__body">
      <img
        src={imgSrc}
        alt={imgAlt || 'Loading...'}
        className="mk-loader__img"
      />
      <div className="mk-loader__text">
        {heading && <h1 className="title-2">{heading}</h1>}
        {subheading && <h2 className="caption-1">{subheading}</h2>}
      </div>
    </div>
  )
}
